module.exports = __webpack_public_path__ + "static/media/bank_zgyh.63526ce4.png";